import { memo } from 'react';

import {
  FileStatusButton,
  FileStatusIconProgressing,
  FileStatusSubtitle,
  FileStatusTitle,
} from '@air/feature-file-status/ui';
import { ChevronDown } from '@air/next-icons';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type BoardRestorationTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type RestoreBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<BoardRestorationTask>, 'title'>;
  onCancel: () => void;
};

export const RestoreBoardPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { title } }: RestoreBoardPanelInProgressPanelItemProps) => {
    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing />}
        title={<FileStatusTitle>Recovering</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovering board: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={
          <FileStatusButton label="Hide" onClick={onCancel}>
            <ChevronDown className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

RestoreBoardPanelInProgressPanelItem.displayName = 'RestoreBoardPanelInProgressPanelItem';
